"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _util = _interopRequireDefault(require("./util"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var sizes = {
  balloonRadius: _util["default"].sizeAdapter(8),
  border: _util["default"].sizeAdapter(1),
  clockPaddingRight: _util["default"].sizeAdapter(4),
  padding: _util["default"].sizeAdapter(16),
  paddingArrow: _util["default"].sizeAdapter(8),
  marginPredefinedMessages: _util["default"].sizeAdapter(4),
  sizeWhenLeftArrowAppears: _util["default"].sizeAdapter(32),
  radius: _util["default"].sizeAdapter(4),
  doubleRadius: _util["default"].sizeAdapter(8)
};
var _default = exports["default"] = sizes;